<template functional>
  <main class="d-flex flex-column p-2 search-page" ref="container">
    <!--
    ============================================================================
    Debug
    ============================================================================
    -->
    <b-modal
      id="modal-debug"
      modal-class="w-100 mw-100 h-100 mh-100 p-4"
      dialog-class="w-100 mw-100 h-100 mh-100 m-0"
      content-class="w-100 mw-100 h-100 mh-100"
      hide-footer
      scrollable
      :title="parent.$t('common.debug')">
      <slot name="debug"></slot>
    </b-modal>

    <!--
    ============================================================================
    Filters
    ============================================================================
    -->
    <full-page-modal
      id="modal-filters"
      ref="modal"
      hide-header-close
      header-bg-variant="primary"
      header-class="text-white"
      :title="parent.$t('common.filters')">
      <div>
        <slot name="parameters"></slot>
      </div>
      <template slot="modal-footer">
        <slot name="search-buttons"></slot>
      </template>
    </full-page-modal>

    <!--
    ============================================================================
    Alerts
    ============================================================================
    -->
    <full-page-modal
      id="modal-alerts"
      hide-footer
      :title="parent.$t('common.alerts')">
      <slot name="alerts"></slot>
    </full-page-modal>

    <!--
    ============================================================================
    Results
    ============================================================================
    -->
    <h3>
      <b-button
        :size="parent.isMdUp ? undefined : 'sm'"
        variant="warning"
        v-b-modal.modal-alerts
        class="float-left mr-2"
        v-if="$slots.alerts || !!$scopedSlots.alerts">
        <i class="fa fa-fw fa-exclamation-triangle"></i>
        <span v-if="parent.isMdUp">&nbsp;{{ parent.$t('common.alerts') }}</span>
      </b-button>

      {{ parent.$t("common.results") }}

      <small v-if="parent.isMdUp && props.resultsSubheader" class="text-info">
        {{ props.resultsSubheader }}
      </small>

      <b-dropdown
        :size="parent.isMdUp ? undefined : 'sm'"
        class="float-right"
        variant="primary"
        :text="parent.$t('common.filters')"
        split
        right
        v-b-modal.modal-filters>
        <b-dropdown-header>{{ parent.$t("common.resultsPerPage") }}</b-dropdown-header>
        <template v-for="(o, index) in props.pageSizeOptions">
          <b-dropdown-item-button
            :key="index"
            :active="props.pageSize === o.value"
            @click.stop.prevent="listeners.selectPageSize(o.value)">
            {{ o.text }}
          </b-dropdown-item-button>
        </template>
      </b-dropdown>
    </h3>
    <div :class="props.resultsWrapperClass">
      <slot name="results"></slot>
    </div>
    <!--
    ============================================================================
    Buttons
    ============================================================================
    -->
    <div class="buttons border-top border-secondary text-right pt-2">
      <b-button
        v-b-modal.modal-debug
        variant="dark"
        v-if="$slots.debug || !!$scopedSlots.debug">
        {{ parent.$t('common.debug') }}
      </b-button>

      <slot name="buttons"></slot>
    </div>
  </main>
</template>
<script>
export default {
  functional: true,

  props: {
    pageSize: {
      type: Number,
      default: 0
    },

    pageSizeOptions: {
      type: Array,
      required: true
    },

    resultsSubheader: {
      type: String,
      default: undefined
    },

    resultsWrapperClass: {
      default: "flex-grow-1 bg-white mt-2 border-right border-secondary"
    }
  }
};
</script>
